<!--
 * @Author: zyq
 * @Date: 2022-10-19 09:57:01
 * @LastEditors: zyq
 * @LastEditTime: 2022-10-25 11:36:17
 * @description:
-->
<template>
  <div id="app">
    <!-- <KeepAlive>
      <router-view v-if="$route.meta.keepAlive"/>
    </KeepAlive> -->
    <router-view/>
  </div>
</template>

<script>
// import VConsole from 'vconsole'

export default {
  // created () {
  //   const vConsole = new VConsole()
  //   console.log(vConsole)
  // }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

html,
body,
#app {
  height: 100%;
  font-family: customFont-Hei;
  background-size: cover;
  overflow-x: hidden;
  //overflow-y: hidden
}
</style>
